// client/src/services/contentApprovalApi.js
// On-Screen 2.0 social content approval workflow. Talks to the routes added
// to server/routes/scheduledPostRoutes.js.

import { getJson, postJson, putJson } from './http';

const base = '/api/schedule';

/** Move a draft / changes-requested post into review. */
export const submitForReview = (postId, note) =>
  postJson(`${base}/${Number(postId)}/submit`, { note });

/** Approve an in-review post (manager+). */
export const approvePost = (postId, note) =>
  postJson(`${base}/${Number(postId)}/approve`, { note });

/** Send an in-review post back for changes (manager+). */
export const requestChanges = (postId, note) =>
  postJson(`${base}/${Number(postId)}/request-changes`, { note });

/** Reject an in-review post (manager+). */
export const rejectPost = (postId, note) =>
  postJson(`${base}/${Number(postId)}/reject`, { note });

/** Full review history for a post. */
export const getReviewHistory = (postId) =>
  getJson(`${base}/${Number(postId)}/reviews`);

/**
 * Edit a scheduled post's content / media / schedule / campaign link.
 * If the post was already approved and the content changed, the server
 * auto-reopens it to 'changes_requested' (reopened: true in the response).
 */
export const editScheduledPost = (postId, payload) =>
  putJson(`${base}/${Number(postId)}`, payload);

// ---------------------------------------------------------------------------
// Team approvals (Growth Phase 10, feature_key "team_approvals"):
// server/routes/approvalRoutes.js, mounted at /api/approvals/:tenant.
// ---------------------------------------------------------------------------
const approvalsBase = (tenant) => `/api/approvals/${Number(tenant)}`;

/**
 * The tenant's approval policy plus what the caller may do:
 * { required, approverMinRole, approverMinRoleConfigurable, role, canApprove, mustSubmit, approverMinRoles }
 */
export const getApprovalPolicy = (tenant) => getJson(`${approvalsBase(tenant)}/policy`);

/** Owner/admin only: { required?: boolean, approverMinRole?: 'owner'|'admin'|'manager' }. */
export const saveApprovalPolicy = (tenant, body) => putJson(`${approvalsBase(tenant)}/policy`, body);

/** { ready, canApprove, waiting: [...], mine: [...] } */
export const getApprovalsInbox = (tenant) => getJson(`${approvalsBase(tenant)}/inbox`);

/** Audit trail for any reviewable entity (today: 'social_post'). */
export const getEntityReviews = (tenant, entityType, entityId) =>
  getJson(`${approvalsBase(tenant)}/${entityType}/${Number(entityId)}/reviews`);

export const APPROVAL_STAGES = [
  'idea', 'draft', 'in_review', 'changes_requested', 'approved', 'rejected', 'archived',
];

export const APPROVAL_LABELS = {
  idea: 'Idea',
  draft: 'Draft',
  in_review: 'In review',
  changes_requested: 'Changes requested',
  approved: 'Approved',
  rejected: 'Rejected',
  archived: 'Archived',
};
